import { FiX } from "react-icons/fi";

import {
  ChipList,
  StatusBadge,
  TypeBadge,
} from "@/app/library/components/molecules";
import type { APILibraryTemplatePackResponseType } from "@/core/data_sources/models/APILibraryTemplatePack";
import { Button } from "@/core/ui/atoms";
import {
  AdminMiniList,
  AdminMiniRow,
  AdminPanel,
  Banner,
} from "@/core/ui/molecules";
import { DrawerTemplate } from "@/core/ui/templates";

type TemplatePackDetailDrawerProps = {
  readonly onClose: () => void;
  readonly pack: APILibraryTemplatePackResponseType;
};

export function TemplatePackDetailDrawer({
  onClose,
  pack,
}: TemplatePackDetailDrawerProps) {
  const templates = pack.templates ?? [];

  return (
    <DrawerTemplate
      content={
        <div>
          <Banner>
            <strong>Install behavior:</strong> atomic · no partial success ·
            idempotent by template_id + version · no merge in V1.
          </Banner>
          <div className="grid grid-cols-1 gap-[18px] xl:grid-cols-[minmax(0,1fr)_340px]">
            <div>
              <h3 className="mb-2 text-[15px] font-extrabold text-ink">
                Templates
              </h3>
              <AdminMiniList>
                {templates.map((template) => (
                  <AdminMiniRow key={String(template.id ?? template.name)}>
                    <span>
                      <strong>{template.name}</strong>
                      <span className="block text-xs text-ink-muted">
                        {template.type} · v{template.version ?? "-"}
                      </span>
                    </span>
                    <span className="flex items-center gap-1.5">
                      <TypeBadge type={template.type} />
                      <StatusBadge status={template.status} />
                    </span>
                  </AdminMiniRow>
                ))}
              </AdminMiniList>
            </div>
            <AdminPanel className="p-[18px]">
              <AdminMiniList>
                <AdminMiniRow>
                  <strong>Status</strong>
                  <StatusBadge status={pack.status} />
                </AdminMiniRow>
                <AdminMiniRow>
                  <strong>Verticals</strong>
                  <ChipList
                    values={pack.verticals?.map(
                      (vertical) => vertical.name ?? vertical.code,
                    )}
                  />
                </AdminMiniRow>
                <AdminMiniRow>
                  <strong>Templates</strong>
                  <span>{templates.length}</span>
                </AdminMiniRow>
              </AdminMiniList>
            </AdminPanel>
          </div>
        </div>
      }
      footer={
        <>
          <Button>Edit</Button>
          <Button variant="primary">
            {pack.status === "active" ? "Disable" : "Activate"}
          </Button>
        </>
      }
      header={
        <div className="flex w-full items-start justify-between gap-3">
          <div>
            <h2 className="text-lg font-extrabold leading-snug text-ink">
              {pack.name}
            </h2>
            <p className="mt-1 text-[13px] text-ink-muted">Template Pack</p>
          </div>
          <button
            aria-label="Close drawer"
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-control border-0 bg-transparent text-ink-subtle transition-colors hover:bg-gray-100 hover:text-ink"
            onClick={onClose}
            type="button"
          >
            <FiX aria-hidden="true" className="h-5 w-5" />
          </button>
        </div>
      }
    />
  );
}
